<template>
    <div
        id="main"
        class="d-flex justify-content-center align-items-center"
    >
        <h1 class="mr-3 pr-3 align-top border-right inline-block align-content-center">
            404
        </h1>
        <div class="inline-block align-middle">
            <h2
                id="desc"
                class="font-weight-normal lead"
            >
                The page you requested was not found.
            </h2>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
};
</script>
